// Membresías F1 (20-oct-2026). Ver api/membershipsApi.ts.
import { Route } from 'react-router-dom';
import MembershipsPage from './pages/MembershipsPage';

export const MembershipsRoutes = [
  <Route key="memberships" path="/dashboard/memberships" element={<MembershipsPage />} />,
];
